<template>
  <div v-if="isDataLoaded">
    <div class="full-width">
      <p class="card-title">
        {{ getString('module.dashboard.stats.logins') }}
      </p>
      <div class="card-block" :class="{'has-redirect':hasRedirect}" @click="redirect()">
        <line-chart
          v-show="dataReady"
          :chartData="data"
          :options="options"
          :height="200"
          :ref="component"
        />
        <!-- Legends -->
        <div
          v-for="(legend, index) in data.legends"
          :key="index"
          class="legend q-ml-md q-mt-md q-mb-sm"
          :class="{
            'text-hidden': data.datasets[index].hidden,
          }"
          @click="toggleData(index)"
        >
          <div :class="legend.color"></div>
          <span>{{ legend.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import statistics from './statisticsComponent';

export default {
  mixins: [statistics],
  data() {
    return {
      component: 'logins',
      data: {
        labels: [],
        datasets: [
          this.initDataset(this.getColor('red')),
          this.initDataset(this.getColor('blue')),
          this.initDataset(this.getColor('purple')),
          this.initDataset(this.getColor('yellow')),
          this.initDataset(this.getColor('orange')),
        ],
        legends: [
          {
            color: 'red',
            label: this.getString('module.dashboard.stats.resource'),
          },
          {
            color: 'blue',
            label: this.getString('module.dashboard.stats.contact.website'),
          },
        ],
      },
      options: {
        scales: this.scaleOptions,
        elements: {
          point: {
            radius: 2,
          },
        },
        legend: {
          display: false,
        },
      },
    };
  },
  methods: {
    handleData() {
      const stats = this.statisticData;
      this.data.datasets[0].data = stats.map(x => x.resource * 1);
      this.data.datasets[1].data = stats.map(x => x.contact_website * 1);
      if (this.type === 'users') {
        this.data.datasets[2].data = stats.map(x => x.contact_oci_enk * 1);
        this.data.datasets[3].data = stats.map(x => x.contact_oci_syntess * 1);
        this.data.datasets[4].data = stats.map(x => x.contact_oci * 1);
        this.addLegend('ociEnk', 'purple');
        this.addLegend('ociSyntess', 'yellow');
        this.addLegend('oci', 'orange');
      }
      this.data.labels = stats.map(x => this.formatDate(x.date, this.labelDateFormat));
      this.dataReady = true;
    },
    addLegend(legend, color) {
      this.data.legends.push(
        {
          color,
          label: this.getString(`module.dashboard.stats.contact.${legend}`),
        },
      );
    },
    redirect() {
      if (this.hasRedirect) {
        this.$router.push({
          name: 'StatisticsOverview',
          params: { activeTab: 'users' },
        });
      }
    },
  },
};
</script>

<style lang="stylus" scoped src="@/styles/components/statistics.styl"></style>
